export const segmentGroupToResultsLeg = (checkoutFlight, group) => {
    return {
        segments: group.segments.map(segment => {
            return checkoutFlight.segments.find(flightSegment => flightSegment.segment.id === segment.id);
        }),
        pricesForFareGroups: [
            {
                fareFamily: Object.assign({}, group.fareFamily),
                prices: [
                    {
                        originalPrice: group.price,
                        price: group.price,
                        priceInMiles: group.priceInMiles,
                        flight: {
                            fares: [],
                            canBePaidByMiles: false,
                            id: checkoutFlight.id,
                            subsidized: false
                        }
                    }
                ]
            }
        ]
    };
};
export const segmentGroupToSelectedFareAdapter = (flightId, group) => {
    var _a, _b;
    return [
        {
            fareGroupId: ((_a = group.fareGroup) === null || _a === void 0 ? void 0 : _a.id) || ((_b = group.fareFamily) === null || _b === void 0 ? void 0 : _b.id),
            prices: [
                {
                    flight: {
                        fares: [],
                        id: flightId
                    },
                    priceInMiles: group.priceInMiles,
                    price: group.price
                }
            ]
        }
    ];
};
export const segmentGroupToPassengerFares = (fares, group) => {
    var _a;
    if (!(fares === null || fares === void 0 ? void 0 : fares.length)) {
        return [];
    }
    const passengerFares = fares.reduce((arr, fare) => [...arr, ...((fare === null || fare === void 0 ? void 0 : fare.passengerFares) || [])], []);
    const groupSegmentIds = new Set(group.segments.map(segment => segment.id));
    const passFares = [];
    for (const fare of passengerFares) {
        if (!((_a = fare.segments) === null || _a === void 0 ? void 0 : _a.some(segment => groupSegmentIds.has(segment.id)))) {
            continue;
        }
        const count = fare.count;
        passFares.push(Object.assign(Object.assign({}, fare), { baseFare: Object.assign(Object.assign({}, fare.baseFare), { amount: fare.baseFare.amount * count }), totalTaxes: Object.assign(Object.assign({}, fare.totalTaxes), { amount: fare.totalTaxes.amount * count }), totalFare: Object.assign(Object.assign({}, fare.totalFare), { amount: fare.totalFare.amount * count }) }));
    }
    return passFares;
};
export const checkoutSegmentGroupToFlightPropsAdapter = (orderId, flight, group, confirmed, canceled) => {
    return {
        orderId,
        isSelected: true,
        flight: segmentGroupToResultsLeg(flight, group),
        // price:flight.seatMap.additionalServices.gdsServices.services,
        selectedFares: segmentGroupToSelectedFareAdapter(flight.id, group),
        passengerFares: segmentGroupToPassengerFares(flight.fares, group),
        canceled: canceled,
        paid: confirmed,
        isPreOpenAvailable: false,
        isPreOpen: false,
        isReturnFlight: group.groupId === '1'
    };
};
